import React from "react";
import { useDispatch } from "react-redux";
import { Icon, noop } from "rhombus-react";

import { openModal } from "reducers/Modal";
import { MODAL_TYPES } from "utils/constants";
import { toFriendlyErrorMessage } from "utils/common";
import { formatRowError } from "widgets/grid/cells/CreativeActionLists/YoutubeUrlActions";

export default function YoutubeUrlImportSocketError(props){
	let dispatch = useDispatch()
		, {
			clearMessage,
			timestamp,
			prettyTime,
			iconInfo = {},
			data = {},
		} = props
		, libraryName = data?.creativeLibrary?.name || "Library"
		, filename = data?.request?.filename || ""
		;

	function viewErrors(e){
		e.preventDefault();

		let rowErrors = data?.response?.data
			, errors = rowErrors?.length ? rowErrors.map(formatRowError) : [toFriendlyErrorMessage(data?.response?.description) || "An unknown error has occurred"]
			;

		dispatch(openModal(MODAL_TYPES.IMPORT_VERSIONS_ERROR, {
			filename,
			errors,
			title: `Error Importing YouTube URL Creatives - ${filename}`,
		}));
	}

	return [
		<i key="status-icon" className={`ft-ic status-icon ${iconInfo.icon}`} title={iconInfo.title} />
		, <div key="body" className="message-body">
			<div className="socket-error-message">
				<span>Error importing YouTube URL creatives file:</span>
				<span title={filename} className="text-overflow filename">{filename}</span>
				<a href="#" onClick={viewErrors}>View Errors</a>
			</div>
		</div>
		, <Icon key="clear" name="clear" iconStyle="fal" className="clear-message" title="Clear Message" onClick={clearMessage} />
		, <b key="empty" />
		, <span key="footer" className="message-footer name-overflow" title={libraryName}>{libraryName}</span>
		, <time key="time" className="message-time" dateTime={timestamp}>{prettyTime}</time>
	];
}

YoutubeUrlImportSocketError.displayName = "YoutubeUrlImportSocketError";
YoutubeUrlImportSocketError.defaultProps = {
	clearMessage:noop,
	prettyTime:"",
	timestamp:"",
	data:{},
	iconInfo:{},
};
